import React from 'react';
import { DescriptiveGPU } from 'prophesier/dist/wrapper/index-with-deps-react.js';

const data = [[1,2,3,4,5],[6,7,8,9,10]];

class DescriptiveGPUSample extends React.Component {
    constructor() {
        super();
        this._onresult = this._onresult.bind(this);
    }
   
    _onresult(event) {
        console.log(event);
    }
    
    render() {
        return (
            <div>
                <DescriptiveGPU result={this._onresult} data={data} />
        </div>);
    }
}

export default DescriptiveGPUSample;

export const textCode = `
import React from 'react';
import { DescriptiveGPU } from 'prophesier/dist/wrapper/index-with-deps-react.js';

const data = [[1,2,3,4,5],[6,7,8,9,10]];

class DescriptiveGPUSample extends React.Component {
    constructor() {
        super()
    }
    _onresult(event) {
        console.log(event.detail.finalResult)
    }

    render() {
        return <DescriptiveGPU result={this._onresult.bind(this)} data={data} />
    }
}

export default DescriptiveGPUSample;
`

export const src = `
const data = [[1,2,3,4,5],[6,7,8,9,10]];

const template = "<prophesier-descriptive-gpu></prophesier-descriptive-gpu>";

document.onreadystatechange = () => {
    if (document.readyState === "complete") {
        const sampleCode  = document.querySelector("._sampleDomElement");
        sampleCode.innerHTML = template
        const element = document.querySelector("prophesier-descriptive-gpu")
        element.addEventListener("result", function(event) {
            const output = JSON.stringify(event.detail.finalResult)
            const time = event.detail.time
            const div = document.createElement("div")
            div.innerHTML = \`\${output} and the time was \${time} ms\`;
			sampleCode.appendChild(div)
		})
        element.data = data;
    }
}
`

export const textCodeJQ = `
    const data = [[1,2,3,4,5],[6,7,8,9,10]];
    const element = $("<prophesier-descriptive-gpu ></prophesier-descriptive-gpu>")
    element.prop({
      data: data
    })
    $(document.body).append(element)
`





// WEBPACK FOOTER //
// ./src/samples/DescriptiveGPUReact.js